import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Vikhrolitopunecabservice() {



  const cardData = {


  keyword: "Vikhroli to Pune Cab Services",

  headingDescription: "Trustline Travels offers reliable Vikhroli to Pune cab services with safe, comfortable, and affordable transportation for business travel, corporate meetings, airport transfers, family vacations, industrial visits, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our experienced chauffeurs ensure punctual pickups, smooth travel via the Mumbai-Pune Expressway, and a hassle-free journey from Vikhroli to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, well-maintained vehicles, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Vikhroli to Pune taxi services.",

  topPlaces: [
    {
      title: "Amanora Park Town",
      description: "Amanora Park Town is one of Pune's most modern integrated townships, offering commercial offices, residential communities, shopping malls, entertainment zones, and lifestyle facilities. It is a preferred destination for professionals and families."
    },
    {
      title: "Bavdhan",
      description: "Bavdhan is a fast-growing residential and commercial locality featuring premium housing projects, educational institutions, office spaces, and excellent connectivity to Baner, Chandani Chowk, and the Mumbai-Pune Expressway."
    },
    {
      title: "Talawade IT Park",
      description: "Talawade IT Park is an emerging technology hub in Pune, home to software companies, IT firms, business centers, and corporate offices. It attracts professionals and business travelers from across Maharashtra."
    },
    {
      title: "Ranjangaon MIDC",
      description: "Ranjangaon MIDC is a major industrial destination housing engineering companies, automobile manufacturers, pharmaceutical industries, and logistics centers. It is an important hub for industrial and corporate travel."
    },
    {
      title: "Koregaon Park",
      description: "Koregaon Park is Pune's premium lifestyle destination, known for luxury hotels, fine dining restaurants, cafés, shopping outlets, and vibrant nightlife. It is popular among tourists and business executives."
    },
    {
      title: "Pune Airport",
      description: "Pune Airport is a major aviation hub connecting Pune with important cities across India. It serves business travelers, tourists, and passengers requiring convenient airport transfer services."
    },
    {
      title: "Raja Dinkar Kelkar Museum",
      description: "Raja Dinkar Kelkar Museum is one of Pune's finest cultural attractions, showcasing thousands of antiques, traditional artworks, sculptures, and historical artifacts collected from across India."
    },
    {
      title: "Pataleshwar Cave Temple",
      description: "Pataleshwar Cave Temple is an ancient rock-cut temple renowned for its unique architecture, intricate stone carvings, and peaceful surroundings. It is a popular heritage attraction in Pune."
    },
    {
      title: "Mulshi Dam",
      description: "Mulshi Dam is a beautiful nature destination surrounded by green hills, serene backwaters, waterfalls, and scenic landscapes. It is one of the most popular weekend getaways near Pune."
    },
    {
      title: "Tikona Fort",
      description: "Tikona Fort is a historic hill fort overlooking Pawna Lake, famous for its trekking routes, panoramic views, and rich Maratha history. It is a favorite destination for trekkers and photography enthusiasts."
    }
  ],






"services": [
{
"name": "Vikhroli to Pune Cab",
"description": "Book Vikhroli to Pune Cab with professional chauffeurs, clean AC Sedan, Ertiga, Innova, Innova Crysta, and SUV vehicles. Enjoy fixed fares, doorstep pickup, online booking, luggage assistance, one way and round trip options, corporate travel, family trips, airport transfers, and reliable 24x7 customer support."
},
{
"name": "Vikhroli to Pune One Way Cab",
"description": "Choose Vikhroli to Pune One Way Cab for affordable intercity travel with transparent pricing, experienced drivers, instant confirmation, clean vehicles, and convenient doorstep pickup."
},
{
"name": "Vikhroli to Pune Station Cab",
"description": "Book Vikhroli to Pune Station Cab for direct railway station transfers with fixed fares, comfortable AC cars, punctual service, and experienced chauffeurs."
},
{
"name": "Vikhroli to Pimpri Chinchwad Cab",
"description": "Reserve Vikhroli to Pimpri Chinchwad Cab for business travel, family trips, corporate rides, and reliable intercity transportation with premium vehicles."
},
{
"name": "Vikhroli to Wanwadi Cab",
"description": "Travel with Vikhroli to Wanwadi Cab offering affordable pricing, spacious vehicles, luggage support, and safe highway journeys with professional drivers."
},
{
"name": "Vikhroli to Pune Innova Crysta Cab",
"description": "Book Vikhroli to Pune Innova Crysta Cab for luxury travel, spacious seating, premium comfort, airport transfers, family vacations, and corporate journeys."
},
{
"name": "Vikhroli to Pune 7 Seater Cab",
"description": "Hire Vikhroli to Pune 7 Seater Cab for group travel with comfortable seating, ample luggage space, experienced chauffeurs, and fixed fares."
},
{
"name": "Vikhroli to Pune Sedan Cab",
"description": "Choose Vikhroli to Pune Sedan Cab for economical outstation travel with clean AC cars, smooth rides, transparent pricing, and professional drivers."
},
{
"name": "Vikhroli to Pune Shivaji Nagar Cab",
"description": "Reserve Vikhroli to Pune Shivaji Nagar Cab with reliable pickup, affordable fares, comfortable vehicles, and hassle-free intercity transportation."
},
{
"name": "Vikhroli to Swargate Cab",
"description": "Book Vikhroli to Swargate Cab for convenient city drop service with fixed pricing, experienced chauffeurs, and comfortable highway travel."
},
{
"name": "Taxi Service in Vikhroli Mumbai",
"description": "Hire Taxi Service in Vikhroli Mumbai for local rides, airport transfers, corporate travel, and outstation journeys with well-maintained vehicles and professional drivers."
},
{
"name": "Vikhroli to Viman Nagar Taxi Service",
"description": "Book Vikhroli to Viman Nagar Taxi Service with punctual pickup, affordable pricing, AC vehicles, and reliable chauffeur-driven transportation."
},
{
"name": "Vikhroli Cabs Service",
"description": "Choose Vikhroli Cabs Service for local and outstation travel with online booking, fixed fares, experienced drivers, and 24x7 customer assistance."
},
{
"name": "Outstation Cabs Taxi Service Mumbai",
"description": "Book Outstation Cabs Taxi Service Mumbai for one way trips, round trips, airport transfers, corporate travel, and family vacations with premium AC vehicles."
},
{
"name": "Vikhroli to Pune Taxi",
"description": "Travel with Vikhroli to Pune Taxi for comfortable intercity rides featuring transparent pricing, professional chauffeurs, clean vehicles, and safe highway travel."
},
{
"name": "Vikhroli to Pune Cab Service",
"description": "Our Vikhroli to Pune Cab Service provides Sedan, Ertiga, Innova, Innova Crysta, and SUV vehicles with fixed fares, online booking, and dependable customer support."
},
{
"name": "Vikhroli to Pune Taxi Booking",
"description": "Complete Vikhroli to Pune Taxi Booking online with instant confirmation, secure reservations, multiple cab options, and affordable fares."
},
{
"name": "Vikhroli to Pune Drop Taxi",
"description": "Book Vikhroli to Pune Drop Taxi for direct one way travel with doorstep pickup, luggage assistance, professional drivers, and comfortable vehicles."
},
{
"name": "Vikhroli to Pune Online Cab Booking",
"description": "Reserve Vikhroli to Pune Online Cab Booking with instant confirmation, transparent pricing, multiple vehicle choices, and 24x7 availability."
},
{
"name": "Vikhroli to Pune Private Cab",
"description": "Choose Vikhroli to Pune Private Cab for exclusive chauffeur-driven travel with flexible pickup timing, premium comfort, and complete privacy."
},
{
"name": "Vikhroli to Pune Outstation Cab",
"description": "Book Vikhroli to Pune Outstation Cab with experienced drivers, AC vehicles, affordable pricing, and reliable long-distance travel."
},
{
"name": "Vikhroli to Pune Cheap Cab",
"description": "Hire Vikhroli to Pune Cheap Cab offering budget-friendly fares, clean vehicles, professional chauffeurs, and dependable outstation transportation."
},
{
"name": "Vikhroli to Pune AC Cab Service",
"description": "Travel comfortably with Vikhroli to Pune AC Cab Service featuring air-conditioned vehicles, fixed fares, experienced drivers, and smooth highway journeys."
},
{
"name": "Vikhroli to Pune Innova Cab",
"description": "Reserve Vikhroli to Pune Innova Cab for family tours, business trips, airport transfers, spacious seating, and premium travel comfort."
},
{
"name": "Vikhroli to Pune Taxi Fare",
"description": "Check Vikhroli to Pune Taxi Fare with transparent pricing, fixed packages, no hidden charges, and multiple vehicle options."
},
{
"name": "Vikhroli East to Pune Cab",
"description": "Book Vikhroli East to Pune Cab with reliable pickup, affordable fares, AC vehicles, and experienced chauffeurs for safe travel."
},
{
"name": "Vikhroli West to Pune Cab",
"description": "Reserve Vikhroli West to Pune Cab for comfortable intercity travel with professional drivers, clean vehicles, and fixed pricing."
},
{
"name": "Vikhroli to Pune Round Trip Cab",
"description": "Choose Vikhroli to Pune Round Trip Cab with flexible return schedules, transparent fares, premium vehicles, and dependable service."
},
{
"name": "Vikhroli to Pune Cab Per Km Rate",
"description": "Check Vikhroli to Pune Cab Per Km Rate with affordable pricing, flexible packages, and Sedan, Ertiga, Innova, and SUV options."
},
{
"name": "Vikhroli to Pune Sedan Taxi",
"description": "Book Vikhroli to Pune Sedan Taxi for affordable, comfortable, and reliable outstation travel with clean AC vehicles and professional chauffeurs."
},
{
"name": "Vikhroli to Pune Innova Crysta Cab",
"description": "Reserve Vikhroli to Pune Innova Crysta Cab for luxury intercity travel with spacious seating, premium comfort, ample luggage space, experienced chauffeurs, and a smooth highway journey."
}
],

"tableData": [
["Vikhroli to Pune Cab", "Vikhroli to Pune One Way Cab"],
["Vikhroli to Pune Station Cab", "Vikhroli to Pimpri Chinchwad Cab"],
["Vikhroli to Wanwadi Cab", "Vikhroli to Pune Innova Crysta Cab"],
["Vikhroli to Pune 7 Seater Cab", "Vikhroli to Pune Sedan Cab"],
["Vikhroli to Pune Shivaji Nagar Cab", "Vikhroli to Swargate Cab"],
["Taxi Service in Vikhroli Mumbai", "Vikhroli to Viman Nagar Taxi Service"],
["Vikhroli Cabs Service", "Outstation Cabs Taxi Service Mumbai"],
["Vikhroli to Pune Taxi", "Vikhroli to Pune Cab Service"],
["Vikhroli to Pune Taxi Booking", "Vikhroli to Pune Drop Taxi"],
["Vikhroli to Pune Online Cab Booking", "Vikhroli to Pune Private Cab"],
["Vikhroli to Pune Outstation Cab", "Vikhroli to Pune Cheap Cab"],
["Vikhroli to Pune AC Cab Service", "Vikhroli to Pune Innova Cab"],
["Vikhroli to Pune Taxi Fare", "Vikhroli East to Pune Cab"],
["Vikhroli West to Pune Cab", "Vikhroli to Pune Round Trip Cab"],
["Vikhroli to Pune Cab Per Km Rate", "Vikhroli to Pune Sedan Taxi"],
["Vikhroli to Pune Innova Crysta Cab", ""]
],





whychoose: [
  {
    WhyChooseheading: "Trusted Vikhroli to Pune Cab Service",
    WhyChoosedescription: "Trustline Cab provides reliable Vikhroli to Pune cab services with comfortable vehicles, experienced chauffeurs, and dependable intercity travel for business and leisure."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Vikhroli",
    WhyChoosedescription: "Enjoy convenient pickup from Vikhroli East, Vikhroli West, railway station, offices, hotels, residential complexes, and nearby Mumbai locations with direct drop anywhere in Pune."
  },
  {
    WhyChooseheading: "Professional Drivers for Safe Travel",
    WhyChoosedescription: "Our skilled drivers ensure a smooth, secure, and comfortable journey with excellent knowledge of the Mumbai–Pune Expressway and alternate travel routes."
  },
  {
    WhyChooseheading: "Premium Fleet for Every Requirement",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your passenger count, luggage, and travel preferences."
  },
  {
    WhyChooseheading: "Transparent & Budget-Friendly Pricing",
    WhyChoosedescription: "Receive competitive fare quotations with complete transparency before booking, ensuring there are no unexpected charges."
  },
  {
    WhyChooseheading: "One Way, Round Trip & Customized Travel",
    WhyChoosedescription: "Book one-way cabs, return journeys, or personalized travel packages designed to suit your itinerary and schedule."
  },
  {
    WhyChooseheading: "Perfect for Corporate, Airport & Family Trips",
    WhyChoosedescription: "Our Vikhroli to Pune cabs are ideal for office travel, airport transfers, family vacations, medical visits, and weekend getaways."
  },
  {
    WhyChooseheading: "24/7 Booking Assistance",
    WhyChoosedescription: "Book your Vikhroli to Pune cab anytime with instant confirmation, responsive customer support, and reliable travel assistance."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Vikhroli to Pune cab service?",
    answer: "Yes, Trustline Cab offers reliable Vikhroli to Pune cab services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Vikhroli to Pune?",
    answer: "Yes, one-way cab services are available with doorstep pickup from Vikhroli and direct drop at your preferred destination in Pune."
  },
  {
    question: "Do you provide pickup from Vikhroli East and Vikhroli West?",
    answer: "Yes, we provide pickup from Vikhroli East, Vikhroli West, railway station, offices, residential areas, and nearby Mumbai locations."
  },
  {
    question: "Which vehicles are available for Vikhroli to Pune travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable long-distance travel."
  },
  {
    question: "Is Vikhroli to Pune cab service available 24 hours?",
    answer: "Yes, our cab services operate 24/7, allowing you to travel according to your preferred schedule."
  },
  {
    question: "Can I book a return cab from Pune to Vikhroli?",
    answer: "Yes, round-trip cab services are available for passengers planning return travel between Pune and Vikhroli."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically included in the confirmed booking quotation."
  },
  {
    question: "Should I reserve my Vikhroli to Pune cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and your preferred pickup timing."
  },
  {
    question: "Do you provide Vikhroli to Pune cabs for corporate travel?",
    answer: "Yes, our cab services are suitable for business meetings, employee transportation, client visits, and regular corporate travel."
  },
  {
    question: "How can I book Vikhroli to Pune Cab Service with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Deshmukh",
    feedback: "Trustline Travels provided an excellent Vikhroli to Pune cab service with punctual pickup, a clean vehicle, and a courteous driver. The journey was smooth, comfortable, and completed on time.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Joshi",
    feedback: "Our travel experience from Vikhroli to Pune was outstanding. The booking process was simple, the cab was spacious, and the driver ensured a safe and relaxing ride throughout the journey.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Vikhroli to Pune Cab Services",
  "image": "https://www.trustlinetravels.com/assets/images/vikhroli-to-pune-cab-services.webp",
  "description":
    "Book Vikhroli to Pune Cab Services with Trustline Travels for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Vikhroli to Pune, Pimpri Chinchwad, Wanwadi, Shivaji Nagar, Swargate, Pune Railway Station, and all Pune locations with Sedan, Ertiga, SUV, Innova, Innova Crysta, and 7-seater cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/vikhroli-to-pune-cab-services"
  }
};


  return (
    <div>
<Helmet>
  <title>Vikhroli to Pune Cab Services | One Way Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Vikhroli to Pune Cab Services with Trustline Travels for reliable one-way and round-trip taxi services. Travel from Vikhroli to Pune, Pimpri Chinchwad, Wanwadi, Shivaji Nagar, Swargate, and Pune Railway Station with Sedan, Ertiga, SUV, Innova, Innova Crysta, and 7-seater cabs available 24x7."
  />

  <meta
    name="keywords"
    content="vikhroli to pune cab, vikhroli to pune one way cab, vikhroli to pune station cab, vikhroli to pimpri chinchwad cab, vikhroli to wanwadi cab, vikhroli to pune innova crysta cab, vikhroli to pune 7 seater cab, vikhroli to pune sedan cab, vikhroli to pune shivaji nagar cab, vikhroli to swargate cab, taxi service in vikhroli mumbai, Vikhroli to Pune Cab Services"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/117.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Vikhrolitopunecabservice;